import S from './AllAnimalls.module.css';
import D from '../images/package.svg'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useGlobalContext } from '../Components/Context';
import NewPacket from '../Components/createModalpacket';
import CollectorsComp from '../Components/DeviceList/CollectorList';
const Packets=()=>{

    const {openModalls,isOpenModal}=useGlobalContext();

  
    return <>
    <div className={S.AllAnimalssCon}>
   <div style={{display:'flex',justifyContent:'space-between',width:'100%',alignItems:'center'}}>
     <div className={S.AllAnimalssTitleCon}>
        <img style={{width:'72px',height:'72px'}} className={S.AllAnimalssIconimgTit} src={D}/>
        <h2>لیست کالکتور ها</h2>
        </div>
          <div onClick={()=>{openModalls()}} data-title='افزودن پکت جدید' className={`${S.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
   </div>
        <hr/>
        <CollectorsComp/>
        {isOpenModal&&<NewPacket/>}
            
                </div>
    </>
}
export default Packets